module.exports = __webpack_public_path__ + "img/20220831_token_plans.9883ad38.png";